rawPattern